import { TipoAtendimentoProfissional } from 'graphql/types.generated'
import { useAtendimentoContext } from 'hooks/atendimento-context/useAtendimentoContext'
import React from 'react'
import { MetaPath } from 'util/metaPath'
import { meta } from 'view/atendimentos/atendimento-individual/model'

import { soapConfig, SoapFormModel } from './config/model'

interface SoapSectionsProps {
  tipoAtendProf: TipoAtendimentoProfissional
  isObservacaoAndAuxiliar: boolean
  renderAntecedentes: () => JSX.Element
  renderSubjetivo: () => JSX.Element
  renderObjetivo: () => JSX.Element
  renderAvaliacao: () => JSX.Element
  renderPlano: () => JSX.Element
  renderFinalizacaoAtendimento: () => JSX.Element
}

function SoapSections(props: Readonly<SoapSectionsProps>) {
  const {
    tipoAtendProf,
    isObservacaoAndAuxiliar,
    renderAntecedentes,
    renderSubjetivo,
    renderObjetivo,
    renderAvaliacao,
    renderPlano,
    renderFinalizacaoAtendimento,
  } = props

  const { isRetificacao } = useAtendimentoContext()
  const hiddenSections = soapConfig(tipoAtendProf, isObservacaoAndAuxiliar, isRetificacao)?.hiddenSections

  const sections: (JSX.Element | null)[] = [
    showSection(meta.antecedentes, hiddenSections) ? renderAntecedentes() : null,
    showSection(meta.subjetivo, hiddenSections) ? renderSubjetivo() : null,
    showSection(meta.objetivo, hiddenSections) ? renderObjetivo() : null,
    showSection(meta.avaliacao, hiddenSections) ? renderAvaliacao() : null,
    showSection(meta.plano, hiddenSections) ? renderPlano() : null,
    showSection(meta.finalizacao, hiddenSections) ? renderFinalizacaoAtendimento() : null,
  ]

  return <>{sections}</>
}

const showSection = (sectionMetaPath: MetaPath<SoapFormModel>, hiddenSections?: MetaPath<SoapFormModel>[]) =>
  !hiddenSections?.includes(sectionMetaPath)

export default React.memo(SoapSections)
